import { Component, Inject, OnInit, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ToastrService } from 'ngx-toastr';
import { UtilityService } from 'src/app/_helpers/utility.service';
import { FileNameData } from 'src/app/_model/FileNameData';
import { Lookup } from 'src/app/_model/Lookup';
import { Overtime } from 'src/app/_model/overtime';
import { ListDocumentRequest } from 'src/app/_model/request/ListDocumentRequest';
import { WfApproveRequest } from 'src/app/_model/request/WfApproveRequest';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { EventService } from 'src/app/_services/event.service';
import { LookupService } from 'src/app/_services/lookup.service';
import { OvertimeService } from 'src/app/_services/overtime.service';
import { StorageService } from 'src/app/_services/storage.service';
import { AppConstants } from 'src/app/_utils/constants';

@Component({
  selector: 'app-overtime-approve',
  templateUrl: './overtime-approve.component.html',
  styleUrls: ['./overtime-approve.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class OvertimeApproveComponent implements OnInit {

  request: WfApproveRequest = new WfApproveRequest();
  currentUser: User;
  approveButtonName = 'Onayla';
  lookupForCurrentovertime: Lookup;
  lookupList: Lookup[];

  overtimeApproveForm: any;
  fileList: FileNameData[] = [];
  fileData: File = null;
  fileUploadProgress: string = null;

  constructor(public dialogRef: MatDialogRef<OvertimeApproveComponent>,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: Overtime,
                private authService: AuthenticationService,
                private overtimeService: OvertimeService,
                private toastr: ToastrService,
                private lookupService: LookupService,
                private storageService: StorageService,
                private utilityService: UtilityService,
                private eventService: EventService) { 
                  this.currentUser = this.authService.currentUserValue;
                }

  ngOnInit() {
    this.lookupForCurrentovertime = this.lookupService.localListLookups()
            .filter(lookup => {
              if (lookup.id === this.data.overtimeTypeId) {
                return lookup;
              }
        })[0];
    
        const listDocumentRequest: ListDocumentRequest = new ListDocumentRequest('OVERTIME', this.data.id);
        this.storageService.listDocuments(listDocumentRequest).subscribe(listResult => {
          this.fileList = [...this.utilityService.mapPortalDocumentResponseToFileNameData(listResult.responseData.items)];
        });
  }

    closeModal(){
      this.dialogRef.close();
    }
  
    approveOvertime() {
      // dosya yukleme zorunlulugu sadece ik icin gecerli
      if (this.currentUser.department.id === 3) {
          if (this.lookupForCurrentovertime.attribute5 != null && this.fileList.length === 0){
              this.toastr.error(this.lookupForCurrentovertime.attribute5 + ' dosyası yüklenmelidir', 'Hata');
              return;
          }
      }
  
      if (this.fileList.length > 0) {
          this.request.fileList = this.fileList;
      }
  
      this.request.employeeId = this.currentUser.employeeId;
      this.request.operationRecordId = this.data.id;
      this.request.operationTableName = 'overtime';
      this.overtimeService.approveOvertime(this.request).subscribe(result => {
        this.toastr.success('Onaylama işlemi başarılı', '');
        this.dialogRef.close(true);
      }, error => {
        this.toastr.error(error.error.msg, 'Hata');
        this.dialogRef.close(false);
      });
    }
  
    fileProgress(fileInput: any) {
        this.fileData = fileInput.target.files[0];
    }
  
    uploadFile() {
        if (this.fileList.length === 2) {
            alert('En fazla iki dosya yüklenebilir');
            return;
        }
  
        const formData = new FormData();
        formData.append('file', this.fileData);
  
        const fileSizeInMb = this.fileData.size / 1024 / 1024;
        if (fileSizeInMb >= AppConstants.FILE_UPLOAD_LIMIT) {
            alert('Dosya boyutu en fazla ' + AppConstants.FILE_UPLOAD_LIMIT + 'mb olmalıdır');
            this.fileData = null;
            return;
        }
  
        this.getBase64(this.fileData).then(value => {
            this.fileList.push(new FileNameData(this.fileData.name, value));
        });
  
        setTimeout(() => this.fileData = null, 500);
    }
  
    deleteFile(index: number) {
        //this.fileList.splice(index, 1);
        this.fileList[index].willBeDeleted = true;
    }
  
    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

}
